class UserData {
  constructor(numOfRounds) {
    this.numOfRounds = numOfRounds;
    this.currentRound = 1;
    this.roundResults = [];
    for (let i = 0; i < numOfRounds; i++) {
      this.roundResults.push(null);
    }
    this.selectedFriend = null;
    this.roundsFinished = false;
    this.playedInstructions = false;
  }

  setRoundResults (value) {
    this.roundResults[this.currentRound - 1] = value;
  }

  getCurrentResults () {
    return this.roundResults[this.currentRound - 1];
  }

  getCurrentScore () {
    return this.roundResults[this.currentRound - 1]?.score;
  }

  levelUp () {
    if (this.currentRound < this.numOfRounds) {
      this.currentRound++;
    }
    else {
      this.roundsFinished = true;
    }
  }

  addFriend (friendID) {
    this.selectedFriend = friendID;
  }

  getChosenFriend () {
    return this.selectedFriend;
  }
}

/** @type {UserData} */
let userData = null;

export function initializeUserData(roundCount) {
  userData = new UserData(roundCount);
}

export default function getUserData() {
  return userData;
}
